export const EXAMINATION_TYPE_OF_GASTROSCOPY = 1
export const EXAMINATION_TYPE_OF_COLONOSCOPY =  2
export const EXAMINATION_TYPE_OF_SIGMOIDOSCOPY = 3

export const PRINT_STATUS_NO = '0'
export const PRINT_STATUS_YES = '1'